import React from "react"
import { Grid, Row, Col, Image } from "react-bootstrap"
import Sidebar from "../components/Sidebar.js"

import facebook from "../assets/facebook.svg"
import instagram from "../assets/instagram.svg"
import behance from "../assets/behance.svg"
import vimeo from "../assets/vimeo.svg"
import { Seo } from "../components/Seo.js"

const links = [
  "https://www.facebook.com/giacomo.bruno.758",
  "https://www.instagram.com/giacomo__bruno",
  "https://www.behance.net/Giacomobru4878",
  "https://vimeo.com/user12683267"
]

const References = () => (
  <Grid fluid className = { "references" }>
    <Seo title="References"></Seo>
    <Row>
      <Col md = { 1 }>
        <Sidebar />
      </Col>
      <Col md = { 9 }>
        <div className = { "social-icons" }>
          <Row>
            {
              [facebook, instagram, behance, vimeo].map((social, index) => (
                <Col xs = { 6 } md = { 3 }>
                  <a href = { links[index] } target = { "_blank" }>
                    <Image responsive className = { "social" } src = { social }/>
                  </a>
                </Col>
              ))
            }
          </Row>
        </div>
      </Col>
    </Row>
  </Grid>
)

export default References



// WEBPACK FOOTER //
// ./src/containers/References.js